function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "triangle-small");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-134.000000, -153.000000)"
}, React.createElement("g", {
  id: "triangle-small",
  transform: "translate(133.886606, 151.157730)"
}, React.createElement("path", {
  d: "M6.11339359,18.8422702 C10.7983324,18.8422702 15.1923671,30.8422702 24.1256375,30.8422702 C33.0589079,30.8422702 -21.8124409,30.8422702 -11.6181635,30.8422702 C-1.42388606,30.8422702 1.42845474,18.8422702 6.11339359,18.8422702 Z",
  id: "Triangle-Copy-2",
  fill: "#2B2B2B",
  transform: "translate(6.113394, 24.842270) rotate(-90.000000) translate(-6.113394, -24.842270) "
}), React.createElement("path", {
  d: "M10.6133936,14.3422702 C15.2983324,14.3422702 19.6923671,25.3422702 28.6256375,25.3422702 C37.5589079,25.3422702 -17.3124409,25.3422702 -7.11816351,25.3422702 C3.07611394,25.3422702 5.92845474,14.3422702 10.6133936,14.3422702 Z",
  id: "Triangle",
  fill: "#2B2B2B",
  transform: "translate(10.613394, 19.842270) rotate(-90.000000) translate(-10.613394, -19.842270) "
}), React.createElement("path", {
  d: "M12.1133936,14.8422702 C16.305181,14.8422702 20.2366857,24.8422702 28.2296118,24.8422702 C36.2225379,24.8422702 -12.8728794,24.8422702 -3.75168381,24.8422702 C5.3695118,24.8422702 7.9216062,14.8422702 12.1133936,14.8422702 Z",
  id: "Triangle-Copy",
  fill: "#4C4C4C",
  transform: "translate(12.113394, 19.842270) rotate(-90.000000) translate(-12.113394, -19.842270) "
}), React.createElement("path", {
  d: "M17.1133936,8.72605193 C17.1133936,15.088481 10.7771144,18.87748 8.19200737,22.272798 C7.52949165,21.4841648 7.11339359,20.6973312 7.11339359,19.8422702 C7.11339359,15.6504828 17.1133936,11.718978 17.1133936,3.72605193 Z",
  id: "Combined-Shape",
  fill: "#343434"
}))));

var SvgTriangleSmall = function SvgTriangleSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "17px",
    height: "41px",
    viewBox: "0 0 17 41",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTriangleSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/triangle-small.02408dc3.svg";
export { ForwardRef as ReactComponent };